import { render, staticRenderFns } from "./JdActivityInfoCard.vue?vue&type=template&id=5b2e76a7&"
import script from "./JdActivityInfoCard.vue?vue&type=script&lang=js&"
export * from "./JdActivityInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./JdActivityInfoCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports